import { render, staticRenderFns } from "./updateDetail.vue?vue&type=template&id=d04edab4&scoped=true"
import script from "./updateDetail.vue?vue&type=script&lang=js"
export * from "./updateDetail.vue?vue&type=script&lang=js"
import style0 from "./updateDetail.vue?vue&type=style&index=0&id=d04edab4&prod&scoped=true&lang=scss"
import style1 from "./updateDetail.vue?vue&type=style&index=1&id=d04edab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04edab4",
  null
  
)

export default component.exports